(() => {
  'use strict';
  const el = document.getElementById('bwl-shopify-config');
  if (!el) return;
  const config = JSON.parse(el.textContent);
  if (!config.enabled) return;
  const api = window.clockPreview;
  const buttons = [...document.querySelectorAll('[data-add]')];
  const status = document.getElementById('bwl-cart-status');
  let busy = false;
  const valid = (variant, expected) => variant && Number.isSafeInteger(variant.id) && variant.id > 0 && variant.available && variant.price === expected;
  function selected() {
    const state = api.getState();
    return {state, base: config.packages[String(state.quantity)], amount: api.calculate(state.quantity, state.extra)};
  }
  function refresh() {
    const {state,base,amount} = selected();
    const ready = config.currency === 'EUR' && valid(base, amount.base) && (!state.extra || valid(config.accessory, amount.extra));
    buttons.forEach(button => {button.disabled = busy || !ready;button.setAttribute('aria-disabled', String(busy || !ready));});
    document.querySelectorAll('.availability-note,.p5-stock-note,.p58-stock').forEach(node => {
      node.hidden = !(base && base.available && base.inventory_tracked && base.inventory > 0 && base.inventory <= 10);
    });
    status.hidden = ready && !busy;
    status.textContent = busy ? config.messages.adding : ready ? '' : config.messages.unavailable;
  }
  document.querySelectorAll('input[name="quantity"]').forEach(input => {
    const variant = config.packages[input.value];
    const expected = api.config.bundles.find(item => item.quantity === Number(input.value)).price_cents;
    input.disabled = !valid(variant, expected);
  });
  const extra = document.getElementById('nordilight-choice');
  if (extra) extra.disabled = !valid(config.accessory, api.config.accessory.price_cents);
  document.querySelectorAll('[data-enable-extra]').forEach(button => {button.disabled = !valid(config.accessory, api.config.accessory.price_cents);});
  document.addEventListener('change', refresh);
  document.addEventListener('click', event => {
    if (event.target.closest('[data-choose-quantity],[data-enable-extra]')) queueMicrotask(refresh);
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-add]');
    if (!button) return;
    event.preventDefault();event.stopImmediatePropagation();
    const {state,base,amount} = selected();
    if (busy || config.currency !== 'EUR' || !valid(base, amount.base) || (state.extra && !valid(config.accessory, amount.extra))) {refresh();return;}
    const items = [{id:base.id, quantity:1}];
    if (state.extra) items.push({id:config.accessory.id, quantity:1});
    busy = true;refresh();
    try {
      const response = await fetch(config.addUrl, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items,sections:'cart-icon-bubble',sections_url:location.pathname})});
      const data = await response.json();
      if (!response.ok || data.status >= 400) throw new Error(data.description || config.messages.error);
      // 19.10.2026: UpCart-Drawer öffnen statt Warenkorbseite (User-Standard), Header-Zähler aktualisieren; Fallback /cart
      const bubble = data.sections && data.sections['cart-icon-bubble'], target = document.getElementById('cart-icon-bubble');
      if (bubble && target) {const html = new DOMParser().parseFromString(bubble, 'text/html').querySelector('.shopify-section'); if (html) target.innerHTML = html.innerHTML;}
      if (typeof window.upcartOpenCart === 'function' || document.getElementById('upCart')) {
        try {if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();} catch (e) {}
        try {if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();} catch (e) {}
        busy = false; refresh(); return;
      }
      window.location.assign(config.cartUrl);
    } catch (error) {
      busy = false;refresh();status.hidden = false;status.textContent = error.message || config.messages.error;
    }
  }, true);
  refresh();
})();
